import React from "react";
import {Card, Typography} from "antd";
import LocaleText from "../../settings/dictionary/LocaleText";
import IBaseProps from "../../../../model/interface/IBaseProps";
import Holidays from "./Holidays";


interface IProps extends IBaseProps{

}

interface IState {

}

class Overview extends React.Component<IProps, IState> {

    render() {
        return (
            <div className={'content-padding'}>
                <Typography.Title><LocaleText code={'system.holidays'} fallback={"Svátky"}/></Typography.Title>
                <Card>
                    <Holidays {...this.props}></Holidays>
                </Card>
            </div>
        )
    }
}

export default Overview;
